import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
const getVerticalBorder = ({ theme }) => css `
  height: 100%;
  border-left: 1px solid ${theme.colors.primary};
  top: 0;
  left: 50%;
`;
const getHorizontalBorder = ({ theme }) => css `
  width: 100%;
  border-bottom: 1px solid ${theme.colors.primary};
  top: 50%;
  left: 0;
`;
export const StepsList = styled.div `
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  gap: 24px;
  align-items: stretch;
  justify-content: center;
  position: relative;

  width: 100%;
  & > * {
    flex: 1;
  }

  &:after {
    content: '';
    position: absolute;
    ${({ $direction, theme }) => $direction === 'row'
    ? getHorizontalBorder({ theme })
    : getVerticalBorder({ theme })}
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    &:after {
      ${({ theme }) => getVerticalBorder({ theme })}
      border-bottom: 0;
    }
  }
`;
const StepsHeaderContainerRowStyle = css `
  flex-direction: row;
  align-items: flex-start;
  text-align: left;
  gap: ${({ theme }) => theme.spacing.xxl}px;
`;
const StepsHeaderContainerColumnStyle = css `
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const StepsHeaderContainer = styled.div `
  display: flex;
  ${({ $direction }) => $direction === 'row'
    ? StepsHeaderContainerRowStyle
    : StepsHeaderContainerColumnStyle}
  height: fit-content;
  width: fit-content;

  ${media.tablet `${StepsHeaderContainerColumnStyle}`}
`;
export const StepsShell = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl}px;
  align-items: center;
`;
export const StepsContent = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $justify }) => $justify};
`;
